import { ClipboardList } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";
import { FormPage } from "./FormPage";

export * from "./api";
export { AggregateView, useAggregate } from "./AggregateView";
export { countRows } from "./FormPage";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const FormsPage = lazyPage(() => import("./FormsPage"), "FormsPage");

export default defineModuleUi({
  key: "forms",
  title: "Formulários",
  domain: "diagnostics",
  icon: ClipboardList,
  menu: [
    {
      path: "/diagnostico/formularios",
      label: "Formulários",
      minRole: "member",
      icon: ClipboardList,
      order: 80,
      keywords: "versões respostas questionário k-anonimato publicar",
    },
  ],
  routes: [
    { path: "/diagnostico/formularios", element: <FormsPage />, minRole: "member" },
    { path: "/diagnostico/formularios/:id", element: <FormPage />, minRole: "member" },
  ],
});
